import VpnDetails from "./VpnDetails";
import VpnList from "./VpnList";
import NodataImage from "../../../assets/baseVersion/nodata_available.svg";
import "./Vpn.css"
import { Button } from "@mui/material";
import AddVpn from "./AddVpn";
import { useEffect, useRef, useState } from "react";
import axiosInstance from "../../../axios/axios";
import { END_POINTS } from "../../../shared";
import { toast } from "react-toastify";
import Skeleton from "react-loading-skeleton";
import { SkeletonLoader } from "../../../modules/dashboard/shared";
import { ROLES_CONTENT_PROPS } from "../../../shared/constants/constant-data";
import useRolePermissions from "../../../shared/hooks/useRolePermissions";

const Vpn = () => {
    const [openAddVpn, setOpenAddVpn] = useState(false);
    const [VPN, setData] = useState<any[]>([]);
    const [isLoading, setLoading] = useState(true);
    const [selectedVpn, setSelectedVpn] = useState<any>(null);
    const [leftSkeletonCount, setLeftSkeletonCount] = useState(0);
    const [rightSkeletonCount, setRightSkeletonCount] = useState(0);
    const leftGridRef = useRef<HTMLDivElement>(null);
    const rightGridRef = useRef<HTMLDivElement>(null);
     const { hasPermissions } = useRolePermissions();

    const statusMap = new Map([
        ['Active', 0],
        ['Failed', 1],
        ['Paused', 2],
        ['Inactive', 3],
        ['Inprogress', 4]
    ]);
    useEffect(() => {
        if (leftGridRef.current) {
            const gridHeight = leftGridRef.current.offsetHeight;
            const count = Math.floor(gridHeight / 40);
            setLeftSkeletonCount(count);

        }
        if (rightGridRef.current) {
            const gridHeight = rightGridRef.current.offsetHeight;
            const count = Math.floor(gridHeight / 40);
            setRightSkeletonCount(count);
        }
    }, [isLoading]);

    const updateVpnStatus = (vpnList: any[]) => {
        return vpnList.map(vpn => {
            const status = vpn.tunnel_status ? vpn.tunnel_status : 'Unknown';
            vpn.status = statusMap.get(status) ?? -1;
            return vpn;
        });
    };

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.get(END_POINTS.VPN);
            if (response.status === 200) {
                setLoading(false);
                // toast(response.data.message, { type: "success" });
                const result = response.data?.data || [];
                const updatedResult = updateVpnStatus(result);
                setData(updatedResult);
                setSelectedVpn(updatedResult[0]);
                setLoading(false);
            }
        } catch (error: any) {
            setLoading(false);
            toast.error(error.response.data
                ? error.response.data.message
                : "Something went wrong", { type: "error" });
        }finally {
            setLoading(false);
        }
       

    };

    const addVpnCall = () => {
        fetchData();
    }

    const getAllVPN = () => {
        fetchData();
    }

    useEffect(() => {
        fetchData();
    }, []);

    const handleVpnSelection = (vpn: any) => {
        setSelectedVpn(vpn);
        console.log("Selected VPN:", vpn);
    };


    return (
        <>
            {isLoading ? (

                <div
                    style={{
                        display: "flex",
                        gap: "16px",
                        flexDirection: "row",
                        width: "100%",
                        height: "100%"
                    }}
                >
                    <div

                        style={{
                            width: "20%"
                        }}
                    >
                        <SkeletonLoader
                            count={Math.floor(window.innerHeight / 40)}
                            styles={{ height: 30 }}
                        />

                    </div>
                    <div

                        style={{
                            width: "80%"
                        }}
                    >
                        <SkeletonLoader
                            count={Math.floor(window.innerHeight / 40)}
                            styles={{ height: 30 }}
                        />
                    </div>

                </div>
            ) : (
                <div className="out-layout">
                    {VPN.length > 0 ? (
                        <div
                            style={{
                                display: "flex",
                                gap: "16px",
                                flexDirection: "row",
                                width: "100%",
                                height: "100%"
                            }}
                        >
                            <div
                                className="vpn-box"
                                style={{
                                    width: "20%"
                                }}
                            >
                                <VpnList vpnData={VPN} onVpnSelect={handleVpnSelection} onFetchVpnCall={addVpnCall} isLoading = {isLoading}/>
                            </div>
                            <div
                                className="vpn-box"
                                style={{
                                    width: "80%"
                                }}
                            >
                                <VpnDetails vpnDetails={selectedVpn} callBaseVPN={getAllVPN} isLoading= {isLoading} />
                            </div>
                        </div>
                    ) : (
                        <div className="no-data-section">
                                    <div className="text_center">
                                        <img src={NodataImage} />
                                        <h3 className="no-data-header">
                                            There is no VPN available,
                                        </h3>
                                        {hasPermissions(ROLES_CONTENT_PROPS.CREATE_VPN) &&
                                            <p className="no-data-text">
                                                Add a VPN to connect SPARK to your private network.
                                            </p>

                                        }
                                        {hasPermissions(ROLES_CONTENT_PROPS.CREATE_VPN) &&
                                            <Button className="add-data-btn"
                                                sx={{
                                                    background: "#3a2ada",
                                                    width: "200px",
                                                    marginTop: "20px",
                                                    color: "white",
                                                    textTransform: "none",
                                                    height: "30px",
                                                    fontSize: "12px",
                                                    "&:focus": { outline: "none" }
                                                }}
                                                onClick={() => setOpenAddVpn(true)}>
                                                Add VPN
                                            </Button>
                                        }
                                    </div>
                        </div>
                    )}
                </div>

            )}

            {openAddVpn && <AddVpn open={openAddVpn} onClose={() => setOpenAddVpn(false)} OnAddVpnCall={addVpnCall} />}
        </>
    );
}

export default Vpn;